/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Full_NegotiationInputs */

const en_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full + negotiation`)
};

const de_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständig + Verhandlung`)
};

const fr_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complet + négociation`)
};

const es_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completo + negociación`)
};

const it_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completo + negoziazione`)
};

const nl_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig + onderhandeling`)
};

const pl_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełne + negocjacje`)
};

const fi_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täydellinen + neuvottelu`)
};

const da_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuld + forhandling`)
};

const sv_pricing_compare_full_negotiation = /** @type {(inputs: Pricing_Compare_Full_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständig + förhandling`)
};

/**
* | output |
* | --- |
* | "Full + negotiation" |
*
* @param {Pricing_Compare_Full_NegotiationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_full_negotiation = /** @type {((inputs?: Pricing_Compare_Full_NegotiationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Full_NegotiationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_full_negotiation(inputs)
	if (locale === "fr") return fr_pricing_compare_full_negotiation(inputs)
	if (locale === "es") return es_pricing_compare_full_negotiation(inputs)
	if (locale === "it") return it_pricing_compare_full_negotiation(inputs)
	if (locale === "nl") return nl_pricing_compare_full_negotiation(inputs)
	if (locale === "pl") return pl_pricing_compare_full_negotiation(inputs)
	if (locale === "fi") return fi_pricing_compare_full_negotiation(inputs)
	if (locale === "da") return da_pricing_compare_full_negotiation(inputs)
	if (locale === "sv") return sv_pricing_compare_full_negotiation(inputs)
	return en_pricing_compare_full_negotiation(inputs)
});